// Auto-generated lightweight class for SysMLUnit
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { SysMLUnitReadAPI, SysMLUnitWriteAPI, SysMLUnitReadAPISchema, SysMLUnitWriteAPISchema } from '../types/sysmlunit';
import { ModelRegistry } from '../../registries/model-registry';
import { DerivedFromUnit } from '../../relationships/relationship';




export interface SysMLUnit extends Partial<SysMLUnitReadAPI> {}
export class SysMLUnit extends NeoNodeBase<SysMLUnitReadAPI, SysMLUnitWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SysMLUnit";
  static readonly readSchema = SysMLUnitReadAPISchema;
  static readonly writeSchema = SysMLUnitWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    derived_units: { target: "SysMLUnit", cardinality: "many", isParent: false, relClass: "DerivedFromUnit", direction: "in" },
    base_unit: { target: "SysMLUnit", cardinality: "one", isParent: false, relClass: "DerivedFromUnit", direction: "out" },
  };

  protected get modelName(): string {
    return 'SysMLUnit';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SysMLUnit.label;
  }


  constructor(data: Partial<SysMLUnitWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SysMLUnitReadAPI, loadContext?: Record<string, any>): SysMLUnit {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { base_unit, derived_units, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SysMLUnitReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, base_unit: base_unit, derived_units: derived_units };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SysMLUnit.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'base_unit', 'SysMLUnit', ModelRegistry);
    loadManyRelationship(processed, 'derived_units', 'SysMLUnit', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SysMLUnit(processed as any);

    return instance;
  }


  // Relationship manager for 'derived_units' - Python ORM style (cached)
  get derived_units(): RelationshipManager<this, SysMLUnit> {
    return this.getOrCreateRelationshipManager('derived_units', () => {
      return new RelationshipManager(this, 'derived_units', 'many', DerivedFromUnit as typeof Relationship);
    });
  }

  // Relationship manager for 'base_unit' - Python ORM style (cached)
  get base_unit(): RelationshipManager<this, SysMLUnit> {
    return this.getOrCreateRelationshipManager('base_unit', () => {
      return new RelationshipManager(this, 'base_unit', 'one', DerivedFromUnit as typeof Relationship);
    });
  }

}
